import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'scoreToColor'
})
export class ScoreToColorPipe implements PipeTransform {

  transform(score: number): string {
    if (score != null) {
      return score < 60 ? '#E73740' :
        score < 80 ? '#F9A91B' : '#4FCC53';
    } else {
      return '#CDD3D8';
    }
  }
}
